import component from "./ChampionshipParticipantsReport.js";

export default component;
